<script>
import Base from '@/views/succezz/components/common-addon.vue';
export default {
  extends: Base,
}
</script>
